// extracted by mini-css-extract-plugin
module.exports = {"InformationCardColumn":"Programs_InformationCardColumn__1UD06"};